import * as InactivityActions from "actions/InactivityActions";
import Controls from "components/Controls";
import getAdCompleted from "selectors/ads/getAdCompleted";
import getControlsHeight from "selectors/styles/getControlsHeight";
import getPlayInitialAd from "selectors/story/getPlayInitialAd";
import getShowAdControls from "selectors/ads/getShowAdControls";
import getShowCompactControls from "selectors/getShowCompactControls";
import getUseMobileControls from "selectors/breakpoint/getUseMobileControls";
import getShowControls from "selectors/getShowControls";
import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";

const connector = connect(
  (state, ownProps) => {
    const showingChapterCover = state.forceChapterCover;
    const showControls =
      getShowControls(state, ownProps) &&
      !state.playerOptions.hidePlayerControls &&
      !showingChapterCover;
    const showCompactControls =
      getShowCompactControls(state, ownProps) &&
      !state.playerOptions.hidePlayerControls &&
      !showingChapterCover;
    const playAd =
      getPlayInitialAd(state, ownProps) && !getAdCompleted(state, ownProps);

    return {
      height: getControlsHeight(state, ownProps),
      showAdControls: showControls && getShowAdControls(state, ownProps),
      showStandardControls:
        !getShowAdControls(state, ownProps) && !playAd && showControls,
      showCompactControls,
      showUnmuteButton: !showControls && state.volume.initiallyMuted,
      useAppearTransition: false,
      useMobileControls:
        getUseMobileControls(state, ownProps) && !showingChapterCover,
    };
  },
  (dispatch) => ({
    onReportActivity: () => dispatch(InactivityActions.reportActivity()),
  }),
);

export default compose(
  connector,
  withHandlers({
    onReportActivity: (props) => props.onReportActivity,
  }),
)(Controls);
